
import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Header from '../News_page/news_header';
import Footer from "../work/footer";
import ContactSubnav from "./contact_subnav";
import ContactDetails from "./contact_details";
import ContactEnquiry from "./contact_enquiry";
import ContactCareer from "./contact_career";
import ContactDownloads from "./contact_downloads";


function ContactPage() {
  return (
    
  <div >
     <Header/>
      {/* <ContactSubnav/> */}
     <ContactDetails/> 
     <div style={{backgroundColor:"white"}}>
     <ContactEnquiry /> 
     <ContactCareer/>  
     <ContactDownloads/>
     </div>
     <Footer/>
  </div>
  );
}

export default ContactPage;